import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import children from './modules/children';
import config from './modules/config';
import user from './modules/user';

const store = createStore({
    modules: {
        children,
        config,
        user
    },
    plugins: [
        createPersistedState({
            // Only persist the selected child and children list
            paths: ['children.children', 'children.selectedChild', 'children.academicYears'],
            // Use localStorage
            storage: window.localStorage,
        })
    ]
});

export default store;